import cx from "clsx";
import React, { useEffect } from "react";
import Modal from "react-modal";
import type ReactModal from "react-modal";
import SSRSuspense from "../../components/SSRSuspense/SSRSuspense";
import useWindowWidth from "../../hooks/useWindowWidth";
import { Colours } from "../../utils/colours";
import type { CmsMapCardProps } from "../SignPostCards";
import { Button } from "../common";
import { Cross } from "../common/Icons";
import * as styles from "./CmsMapLocationModal.module.scss";
export interface CmsMapLocationModalProps extends CmsMapCardProps {
	modalState: boolean;
	onClickCancel: () => void;
}

export const CmsMapLocationModal: React.FC<CmsMapLocationModalProps> = ({
	modalState,
	title,
	subTitle,
	location,
	secondaryInfoTitle,
	secondaryInfoText,
	tertiaryInfoText,
	googleMapsUrl,
	onClickCancel,
}) => {
	const windowWidth = useWindowWidth();

	const customStyles = {
		content: {
			padding: windowWidth > 600 ? "40px" : "16px",
			top: "50%",
			left: "50%",
			right: "auto",
			bottom: "auto",
			marginRight: "-50%",
			transform: "translate(-50%, -50%)",
			boxSizing: "border-box",
			border: "2px",
			borderStyle: "solid",
			borderColor: Colours.SUNSHINE_YELLOW,
			borderRadius: "10px",
			boxShadow: "0px 4px 34px 0px rgba(0, 0, 0, 0.25)",
			maxHeight: "80vh",
			maxWidth: "80vw",
			minWidth: "75vw",
			backgroundColor: Colours.WHITE,
		},
		overlay: {
			zIndex: "9999",
		},
	} as ReactModal.Styles;

	useEffect(() => {
		if (modalState) {
			document.getElementsByTagName("body")[0].style.overflow = "hidden";
		} else {
			document.getElementsByTagName("body")[0].style.overflow = "scroll";
		}
		return () => {
			document.getElementsByTagName("body")[0].style.overflow = "scroll";
		};
	}, [modalState]);

	return (
		<SSRSuspense>
			<Modal
				isOpen={modalState}
				style={customStyles}
				preventScroll={true}
				shouldCloseOnEsc={true}
				shouldCloseOnOverlayClick={true}
				shouldFocusAfterRender={true}
				shouldReturnFocusAfterClose={true}
				ariaHideApp={false}
			>
				<button
					type="button"
					className={styles.iconWrapper}
					onClick={onClickCancel}
					aria-label="Close modal"
				>
					<Cross />
				</button>
				<div className={styles.modalcontainer}>
					<div className={styles.text}>
						<h4 className={styles.title}>{title}</h4>
						<p className={styles.subheading}>{subTitle}</p>
					</div>
					<div className={styles.cardsectionbreak} />
					<div className={styles.textcontainer}>
						<div className={styles.text}>
							<h5 className={styles.heading}>Location</h5>
							<p className={styles.cardtext}>{location}</p>
							{googleMapsUrl && (
								<a
									className={styles.gmaplink}
									target="_blank"
									rel="noreferrer"
									href={googleMapsUrl}
								>
									Google maps
								</a>
							)}
						</div>
						<div className={styles.text}>
							<h5 className={styles.heading}>{secondaryInfoTitle}</h5>
							<p className={cx(styles.cardtext, styles.nomargin)}>
								{secondaryInfoText}
							</p>
						</div>
					</div>
					<div className={styles.cardsectionbreak} />
					<div
						className={styles.htmltext}
						// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
						dangerouslySetInnerHTML={{ __html: tertiaryInfoText }}
					/>
					<div className={styles.cardsectionbreak} />
					<Button
						onClick={onClickCancel}
						onKeyDown={(e) => e.key === "Enter" && onClickCancel}
						variant="tertiary"
						ariaLabel="close modal"
					>
						Close
					</Button>
				</div>
			</Modal>
		</SSRSuspense>
	);
};

export default CmsMapLocationModal;
